import { NumberInput } from '@mantine/core';
import { DatesRangeValue } from '@mantine/dates';
import { GuestBirthdayLiteModel } from 'api-hooks/cro/model';
import { useGetGuestBirthdays } from 'api-hooks/cro/query';
import { NavigationRoutes } from 'common/constants';
import notification from 'components/common/notification';
import Separator from 'components/common/separator';
import PaginationComponent from 'components/elements/pagination-component';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import Text from 'components/elements/text';
import { useApplyQueryFilter } from 'hooks/filter/use-apply-query-filter';
import useApplyQuerySort from 'hooks/use-apply-query-sort';
import useComposedQuery from 'hooks/use-composed-query';
import useDate from 'hooks/use-date';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import { CardContainer, TableContainer } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

// const monthToMilisecond = 1 * 7 * 24 * 60 * 60 * 1000;

interface BirthdayScheduleTableProps {}

export default function BirthdayScheduleTable(
  props: BirthdayScheduleTableProps,
) {
  const { t } = useTranslation();
  const today = new Date();
  const formatDate = useDate();

  const [page, setPage] = React.useState(1);
  //
  const [n, setN] = React.useState(7);

  const dayToMilisecond = React.useCallback((n: number) => {
    return n * 24 * 60 * 60 * 1000;
  }, []);

  const [, setDate] = React.useState<DatesRangeValue>([
    today,
    new Date(today.getTime() + dayToMilisecond(n)),
  ]);

  // const birthday_at_before = date[1] ? format(date[1], 'yyyy-MM-dd') : null;
  // const birthday_at_after = date[0] ? format(date[0], 'yyyy-MM-dd') : null;

  //change date to n
  // const onChangeDate = React.useCallback((value: DatesRangeValue) => {
  //   const startAt = value[0]?.getTime();
  //   const endAt = value[1]?.getTime() || startAt;
  //   setDate(value);
  //   if (!startAt) return;
  //   if (!endAt) return;
  //   const n = startAt - endAt;
  //   setN(n < 0 ? 0 : n);
  // }, []);

  //change n to date
  const onChangeDay = React.useCallback(
    (day: number | '') => {
      if (typeof day === 'number' && day < 0) return;
      const startIn = new Date().setHours(7, 0, 0, 0);
      const endIn = startIn + dayToMilisecond(day || 0);
      setDate([new Date(startIn), new Date(endIn)]);
      setN(day || 0);
    },
    [dayToMilisecond],
  );

  const _columns = React.useMemo<IColumn<GuestBirthdayLiteModel>[]>(() => {
    return [
      {
        accessorKey: 'name',
        sortName: 'name',
        header: t('common:guest'),
        minSize: 180,
      },
      {
        accessorKey: 'birthDate',
        sortName: 'birth_date',
        header: t('common:date_of_birth'),
        cell({ row }) {
          const birthDate = row.original.birthDate;
          return birthDate ? formatDate(birthDate, 'dd MMM yyyy') : '-';
        },
      },
      {
        accessorKey: 'category',
        sortName: 'category',
        header: t('common:category'),
        cell({ row }) {
          const category = row.original.category;
          return (category || '').toUpperCase();
        },
      },
    ];
  }, [formatDate, t]);

  const {
    data,
    isLoading,
    isFetching,
    error,
    extras: [, { columns }],
  } = useComposedQuery(
    useGetGuestBirthdays,
    {
      params: {
        page,
        // filter: {
        //   birthday_at_after,
        //   birthday_at_before,
        // },
        n,
      },
    },
    useApplyQueryFilter((data: any) => {
      return data.filters;
    }),
    useApplyQuerySort((data: any) => {
      return data.sorts;
    }, _columns),
  );

  React.useEffect(() => {
    if (!!error && !!error.message) {
      notification.error({ message: error?.message });
    }
  }, [error]);

  const permission = useGetCrudPermission('guests');

  return (
    <CardContainer>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Text variant="LabelLarge">{t('common:guests_birthday_reminder')}</Text>
        <NumberInput
          defaultValue={n}
          onChange={onChangeDay}
          hideControls
          miw={120}
          h={32}
          radius="md"
          maw={120}
          rightSection={
            <Text
              variant="ParagraphSmall"
              $style={{
                marginRight: '32px',
              }}
            >
              {t('common:days')}
            </Text>
          }
        />
        {/* <DatePickerInput
          type="range"
          value={date}
          onChange={onChangeDate}
          miw={230}
          maw={230}
          clearable
        /> */}
      </div>
      <Separator gap={16} />
      <TableContainer
        $style={{
          maxHeight: '300px',
        }}
      >
        <TableComponent
          columns={columns}
          isLoading={isLoading || isFetching}
          data={data?.data || []}
          rowLink={({ original }) => {
            if (!permission.view) return undefined;
            return {
              pathname: NavigationRoutes.GuestsView,
              query: {
                id: original.id,
              },
            };
          }}
        />
      </TableContainer>
      <PaginationComponent
        page={page}
        onPageChange={(page) => {
          setPage(page);
        }}
        meta={data?.meta}
      />
    </CardContainer>
  );
}
